import Template from "./template";
import BaseRoute from "../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../lib/itn-ui-kit/services/service-container";

export default class FollowUpClientRoute extends BaseRoute {
  @service landingService;
  @service("repositories/provider-client-status-repository") providerClientStatusRepository;

  element = (<Template />);

  async loader({ params }) {
    const { id } = params;

    // TODO: remove this
    const mockedData = {
      "sections": [
        {
          "header": "Follow Up Details",
          "question_1": {
            "question": "Due Date",
            "initial_data": ["2025-06-26T16:25:00"],
            "module": "text"
          }
        },
        {
          "header": "Communication & Treatment",
          "question_2": {
            "question": "Preferred Communication Type",
            "initial_data": ["Email"],
            "module": "choice"
          },
          "question_3": {
            "question": "How is treatment going?",
            "initial_data": [
              "Treatment has been going well overall. I've noticed gradual improvement, especially with mobility and daily function. Some days are better than others, but I’m staying consistent with appointments and exercises."
            ],
            "module": "text"
          }
        },
        {
          "header": "Pain & Injuries",
          "question_4": {
            "question": "What are your injuries?",
            "initial_data": ["Whiplash, Sprains & Strains, Contusions (Bruises)"],
            "module": "choice"
          },
          "question_5": {
            "question": "On a scale from 0 to 10, how would you rate your pain overall? Ask about specific areas.",
            "initial_data": [
              {
                "location": "Overall Pain",
                "rating": 7
              },
              {
                "location": "Neck",
                "rating": 5
              },
              {
                "location": "Lower Back",
                "rating": 5
              },
              {
                "location": "Right Shoulder",
                "rating": 9
              }
            ],
            "module": "client_injuries"
          }
        },
        {
          "header": "Appointments",
          "question_6": {
            "question": "Have you received any recommended procedures? If yes, what type?",
            "initial_data": ["Whiplash, Sprains & Strains, Contusions (Bruises)"],
            "module": "text"
          },
          "question_7": {
            "question": "Can you confirm completed, missed, and next appointments?",
            "initial_data": [
              {
                "type": "Christopher Manning",
                "date": "2025-06-22",
                "time": "09:00 AM",
                "status": "Treating"
              },
              {
                "type": "Christopher Manning",
                "date": "2025-06-23",
                "time": "11:30 AM",
                "status": "Treating"
              }
            ],
            "module": "client_appointment"
          }
        },
        {
          "header": "Providers",
          "question_8": {
            "question": "Confirm providers listed in the app. Any new providers?",
            "initial_data": [
              {
                "name": "The Spine Tingler - Augusta, GA",
                "network": "In Network",
                "notes": "(Chiropractor, X-Rays, CT Scans, MRI Scans, Trigger Point Injections)",
                "status": "Confirmed Provider"
              },
              {
                "name": "Twist & Shout Chiropractic - Opa-locka, FL",
                "network": "In Network",
                "notes": "(Chiropractor, X-Rays, CT Scans, MRI Scans, Trigger Point Injections)",
                "status": "Pending"
              }
            ],
            "module": "client_providers"
          }
        },
        {
          "header": "Referrals",
          "question_9": {
            "question": "Have you been referred to any new providers, such as MRI, Pain Management, or Orthopedics?",
            "initial_data": ["Yes"],
            "module": "boolean"
          },
          "question_10": {
            "question": "If yes, can you confirm the new providers?",
            "initial_data": [
              {
                "from": "Christopher Manning",
                "to": "Dr. Paige Turner"
              },
              {
                "from": "Christopher Manning",
                "to": "Dr. Paige Turner"
              }
            ],
            "module": "client_referral"
          }
        }
      ]
    }

    if (!id || id === "undefined") {
      console.error("Case id not found");
      return { providersClient: null };
    } else {
      try {
        const providersClient = await this.providerClientStatusRepository.query({ case: id });
        return { providersClient, mockedData };
      } catch (error) {
        console.error(`Error getting case: ${id}`, error);
        return { providersClient: null };
      }
    }
  }
}
